import React from 'react';
import './Spinner.css';

const Spinner = () => {
  return (
    <div className="spinner my-4">
      <div className="bounce1"></div>
      <div className="bounce2"></div>
      <div className="bounce3"></div>
    </div>
  );
};

export default Spinner;